import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '../routes'
import Guard from './Guard'
import i18n from "./i18n";

Vue.use(VueRouter)

const router = new VueRouter({
    routes,
    mode:            'history',
    linkActiveClass: 'is-active',
})

router.beforeEach((to, from, next) => {

    let title      = to.meta.title

    // IF the title contains at least one ., we assume it's a translation key
    if (typeof title !== 'undefined' && title.indexOf('.') !== -1) {
        title = i18n.t(title)
    }

    document.title = !!title ? `${title} | Gifty` : 'Gifty'

    Guard.hasAccess(to, from, next)
})

export default router
